import { ReactElement, useCallback, useState } from "react";

import Button from "../Button";
import PopUp from "../PopUp";

export type Props = {
  readonly title: string;
  readonly description: string;
};

const HelpPopup = ({ title, description }: Props): ReactElement => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleTogglePopup = useCallback(
    () => setIsPopupOpen((prevState) => !prevState),
    []
  );

  const handleClosePopup = useCallback(() => setIsPopupOpen(false), []);

  return (
    <>
      {isPopupOpen && (
        <PopUp
          title={title}
          description={description}
          onClose={handleClosePopup}
        />
      )}
      <Button onClick={handleTogglePopup} aria-label="Toon speluitleg">
        ?
      </Button>
    </>
  );
};

export default HelpPopup;
